import React, { useEffect } from 'react';
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import CloseButton from 'components/CloseButton';
import Animated from 'components/Animated';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

const Slider: React.FC = () => {
  const slider = useSelector((state: RootState) => state.slider);
  const title = useSelector((state: RootState) => state.title);
  const dispatch = useDispatch();

  useEffect(() => {
    if (slider?.show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
  }, [slider]);

  return (
    <>
      {slider?.show && (
        <Row className="fixed top-0 bottom-0 right-0 left-0 bg-modal z-999" />
      )}
      <Animated
        show={!!slider?.show}
        animationIn="slideInRight"
        animationInDelay="faster"
        animationOut="slideOutRight"
        animationOutDelay="faster"
        className={`fixed top-0 right-0 bottom-0 bg-white d-flex align-center justify-center z-999 w-${slider?.width || '50'
          } w-md-100-vw`}
      >
        <div className={`relative pt-4 pr-4 pl-4 pb-4 pt-md-4 bg-white h-100 w-100 ${title?.hide ? 'overflow-y-hide' : 'overflow-y-auto'}`}>
          <Row className="justify-end flex-1">
            <CloseButton onClick={() => { dispatch({ type: 'CLOSE_SLIDER' }); dispatch({ type: 'SHOW_TITLE' }); }} />
          </Row>
          {!title?.hide && (
            <>
              <Row className="align-center mt-7">
                <Text size={24} className="color-primary font-bold">
                  {slider?.title}
                </Text>
              </Row>
              {slider?.subtitle && (
                <Row className="align-center mt-3">
                  <Text className="text-wrap" size={12}>
                    {slider?.subtitle}
                  </Text>
                </Row>
              )}
            </>
          )}
          {slider?.content && <slider.content />}
        </div>
      </Animated>
    </>
  );
};

export default Slider;
